import {jsx} from 'panel';
import type {JsxVNodeChildren} from 'snabbdom-jsx-lite';

import {ButtonEl} from 'common/components/button';
import {ButtonTheme} from 'common/components/button/constants';
import {InputEl} from 'common/components/input';

/**
 * Search bar for a child menu, all children passed into this component
 * are rendered to the right side of the search input
 */
export function MenuSearchBar(
  {
    value,
    handleSearchInput,
    backButtonClick,
    placeholder = `Search...`,
    onInsert,
    key = null,
    isBetaMenu = false,
  }: {
    value: string;
    handleSearchInput: (value: string) => void;
    backButtonClick?: () => void;
    placeholder?: string;
    onInsert?: (ev: HTMLElement) => void;
    key?: string;
    isBetaMenu?: boolean;
  },
  children: JsxVNodeChildren = null,
) {
  return (
    <div sel='.search-wrapper' key={key}>
      {backButtonClick && (
        <ButtonEl
          attrs={{
            icon: `arrow-left`,
            theme: ButtonTheme.Tertiary,
            role: `button`,
            tabindex: 0,
          }}
          on={{
            click: backButtonClick,
          }}
        />
      )}
      <InputEl
        attrs={{
          icon: isBetaMenu ? `search` : ``,
          'auto-focus': true,
          placeholder,
          'show-clear': true,
          elref: `searchInput`,
        }}
        props={{value}}
        on={{
          input: (ev) => handleSearchInput(ev.target.value),
          clear: () => handleSearchInput(``),
        }}
        hook={{
          insert:
            onInsert &&
            ((vnode) => {
              const el = vnode.elm as HTMLElement;
              onInsert(el);
              el.focus();
            }),
        }}
      />

      {/* displays arbitrary content the the side of the search bar */}
      {children}
    </div>
  );
}
